/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './version';
export * from './animation/animation';
export * from './common-behaviors/index';
export * from './datetime/index';
export * from './error/error-options';
export * from './line/line';
export * from './option/index';
export * from './ripple/index';
export * from './selection/index';



// WEBPACK FOOTER //
// ../../../../../src/material/core/public-api.ts